import { Controller } from '@hotwired/stimulus'

// Shows or hides index-vessel label sections based on whether any vessel needs them.
// Handles: (1) custom section — data-show-custom; (2) speed/consumption — Yes/No select.
export default class extends Controller {
  static targets = ['labelsCustomSection', 'showSpeedSelect', 'staticLabel', 'vesselCustomSection']

  connect() {
    this.syncCustomSection({})
    this.syncSpeedConsSection({})
    this.element.addEventListener('value-guidance:syncCustomSectionVisibility', (e) => this.syncCustomSection(e.detail || {}))
    this.element.addEventListener('value-guidance-form:speedConsToggled', (e) => this.syncSpeedConsSection(e.detail || {}))
    this.element.addEventListener('value-guidance-speed-cons-toggle:refresh', () => this.syncSpeedConsSection({}))
  }

  syncCustomSection(detail) {
    const anyShown = detail.forceShow || this.element.querySelectorAll('.vessel-form.calc-vessel[data-show-custom="true"]').length > 0

    if (this.hasLabelsCustomSectionTarget) {
      this.labelsCustomSectionTargets.forEach((el) => el.classList.toggle('d-none', !anyShown))
    }
    if (this.hasVesselCustomSectionTarget) {
      this.vesselCustomSectionTargets.forEach((el) => el.classList.toggle('d-none', !anyShown))
    }
  }

  syncSpeedConsSection(detail) {
    if (!this.hasShowSpeedSelectTarget) return
    const anyShown = detail.forceShow === true ? true : this.showSpeedSelectTargets.some((el) => el.value === 'true')
    if (this.hasStaticLabelTarget) {
      this.staticLabelTargets.forEach((el) => el.classList.toggle('d-none', !anyShown))
    }
    this.element.dispatchEvent(new CustomEvent('value-guidance-speed-cons-toggle:syncSections', { bubbles: true, detail: { anyShown } }))
  }
}
